import { mapSiteEmployeeType, mapSiteEmployeeTypes } from '../Types/HeyTraderTypes/Attendances/SiteEmployeeType';
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllSpendingProjectListService, getAllSpendingProjectShopListService } from "../../Api/HeyTraderService/ProjectSpendingService";
import { mapSpendingTyps } from "../Types/HeyTraderTypes/ProjectSpending/ProjectSpendingTypes";
import { mapShopTypes } from "../Types/HeyTraderTypes/ProjectSpending/PojectSpendingShopType";
import { getAllClientAccountCompanies, getAllClientAccountProjectListService } from "../../Api/HeyTraderService/ClientAccountService";
import { mapClientProjectTypes } from "../Types/HeyTraderTypes/ClientAccountTypes/ClientAccountProjectType";
import { getAllMaterialCategoryListService, getAllMaterialProjectListService, getAllMaterialTemplateListService, getAllMaterialUnitListService } from "../../Api/HeyTraderService/MaterialsService";
import { mapMaterialProjectTypes } from "../Types/HeyTraderTypes/Materials/MaterialPojectType";
import { mapMaterialCategoryTypes } from "../Types/HeyTraderTypes/Materials/MaterialCategoryType";
import { mapMaterialUnitTypes } from "../Types/HeyTraderTypes/Materials/MaterialUnitType";
import { mapMaterialTemplateTypes } from "../Types/HeyTraderTypes/Materials/MaterialTemplateType";
import { getAttendanceByEmployeeService, getAttendanceEmployeeListService, getAttendanceHomeListService, getAttendanceProjectListService, getAttendanceTakenListService, getContactEmployeeListService } from "../../Api/HeyTraderService/AttendanceServices";
import { mapContactEmployeeTypes } from "../Types/HeyTraderTypes/Attendances/ContactEmployeeType";
import { mapAttendanceTakenTypes } from '../Types/HeyTraderTypes/Attendances/AttendanceTakenType';
import { mapEmployeeAttendanceType } from '../Types/HeyTraderTypes/Attendances/EmployeeAttendanceType';
import { getToolBrandsService, getToolCategoriesService, getToolsService, getToolStorageService, getToolTypesService } from '../../Api/HeyTraderService/ToolsService';
import { mapToolListDatas } from '../Types/HeyTraderTypes/Tools/ToolListData';
import { mapStorageLists } from '../Types/HeyTraderTypes/Tools/StorageList';
import { mapToolCategoryLists } from '../Types/HeyTraderTypes/Tools/ToolCategoryList';
import { mapToolTypes } from '../Types/HeyTraderTypes/Tools/ToolType';
import { mapBrandLists } from '../Types/HeyTraderTypes/Tools/BrandList';
import { getCommonProjectListService } from '../../Api/HeyTraderService/CommonApiService';
import { mapCommonProjectTypes } from '../Types/HeyTraderTypes/CommonProjectType';
import { mapAttendanceHomeTypes } from '../Types/HeyTraderTypes/Attendances/AttendanceHomeType';
import { mapClientAccountCompanies } from '../Types/HeyTraderTypes/ClientAccountTypes/ClientAccountType';
import { mapAttendanceProjectTypes } from '../Types/HeyTraderTypes/Attendances/AttendanceProjectType';


// get all spending project list
export const getAllSpendingProjectList = createAsyncThunk('getAllSpendingProjectList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllSpendingProjectListService();
    if (response.status) {
      return mapSpendingTyps(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

// get all shops
export const getAllSpendingShopList = createAsyncThunk('getAllSpendingShopList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllSpendingProjectShopListService();
    if (response.status) {
      return mapShopTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all shop details');
  }
});

// get all client account project list
export const getAllClientProjectList = createAsyncThunk('getAllClientProjectList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllClientAccountProjectListService();
    if (response.status) {
      return mapClientProjectTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

// company list
export const getAllCompanyList = createAsyncThunk('getAllCompanyList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllClientAccountCompanies();
    if (response.status) {
      return mapClientAccountCompanies(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all companies');
  }
});

//her materials start

//  material project list
export const getAllMaterialProjectList = createAsyncThunk('getAllMaterialProjectList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllMaterialProjectListService();
    if (response.status) {
      return mapMaterialProjectTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

//  material category list
export const getAllMaterialCategoryList = createAsyncThunk('getAllMaterialCategoryList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllMaterialCategoryListService();
    if (response.status) {
      return mapMaterialCategoryTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

//  material unit list
export const getAllMaterialUnitList = createAsyncThunk('getAllMaterialUnitList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllMaterialUnitListService();
    if (response.status) {
      return mapMaterialUnitTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

//  material unit list
export const getAllMaterialTemplateList = createAsyncThunk('getAllMaterialTemplateList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAllMaterialTemplateListService();
    if (response.status) {
      return mapMaterialTemplateTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});


//ATTENDANCE

// get contact employee list
export const getContactEmployeeList = createAsyncThunk('getContactEmployeeList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getContactEmployeeListService();
    if (response.status) {
      return mapContactEmployeeTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

// get attendance employee list
export const getAttendanceEmployeeList = createAsyncThunk(
  'getAttendanceEmployeeList',
  async (date: string | null | undefined, { rejectWithValue }) => {
    try {
      const response = await getAttendanceEmployeeListService(date);

      if (response.status) {
        return mapSiteEmployeeTypes(response.body);
      } else {
        return rejectWithValue(response.error);
      }
    } catch (error: any) {
      return rejectWithValue('Failed to fetch attendance employee list');
    }
  }
);


// get attendance employee list
export const getAttendanceTakenList = createAsyncThunk('getAttendanceTakenList', async (attendance_date: string, { rejectWithValue }) => {
  try {
    // api
    const response = await getAttendanceTakenListService(attendance_date);

    if (response.status) {
      return mapAttendanceTakenTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});



// get attendance home list
export const getAttendanceHomeList = createAsyncThunk('getAttendanceHomeList', async (attendance_date: string, { rejectWithValue }) => {
  try {
    // api
    const response = await getAttendanceHomeListService(attendance_date);
    if (response.status) {
      return mapAttendanceHomeTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});




// get attendance employee list
export const getAttendanceByEmployeeList = createAsyncThunk('getAttendanceByEmployeeList', async (collection: string[], { rejectWithValue }) => {
  try {
    // api
    const response = await getAttendanceByEmployeeService(collection);
    if (response.status) {
      return mapEmployeeAttendanceType(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});


//  Tools thunks start

// get tool brand list
export const getToolBrandList = createAsyncThunk('getToolBrandList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getToolBrandsService();
    if (response.status) {
      return mapBrandLists(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

// get tool castegory list
export const getToolTypeList = createAsyncThunk('getToolTypeList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getToolTypesService();
    if (response.status) {
      return mapToolTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

// get tool castegory list
export const getToolCategoryList = createAsyncThunk('getToolCategoryList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getToolCategoriesService();
    if (response.status) {
      return mapToolCategoryLists(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

// get tool storage list
export const getToolStorageList = createAsyncThunk('getToolStorageList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getToolStorageService();
    if (response.status) {
      return mapStorageLists(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});

// get tool list
export const getToolList = createAsyncThunk('getToolList', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getToolsService();
    if (response.status) {
      return mapToolListDatas(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});


// get common project list
export const getCommonProjects = createAsyncThunk('getCommonProjects', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getCommonProjectListService();
    if (response.status) {
      return mapCommonProjectTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});


// get attendance project list
export const getAttendanceProjects = createAsyncThunk('getAttendanceProjects', async (_, { rejectWithValue }) => {
  try {
    // api
    const response = await getAttendanceProjectListService();
    if (response.status) {
      return mapAttendanceProjectTypes(response.body);
    } else {
      // If the API returns a failure status, return the error message
      return rejectWithValue(response.error);
    }
  } catch (error: any) {
    // Handle the case where the API call itself throws an error
    return rejectWithValue('Failed to fetch all projet details');
  }
});